module.exports = __webpack_public_path__ + "img/4bg@2x.7f94528a.png";